module.exports = __webpack_public_path__ + "static/media/batteries-paywall-header.9518ea5f.png";